import "core-js/modules/es.array.join";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { activityTimeManager } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewPage],
  props: {
    propsData: Object
  },
  data: function data() {
    return {
      dialogShow: false,
      serverID: [],
      paramsData: {
        env_id: '',
        actID: '',
        startTime: '',
        middleTime: '',
        endTime: '',
        server_id: '',
        op: "set"
      },
      rules: {
        startTime: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        middleTime: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        server_id: [{
          required: true,
          message: this.$t('pleaseSelectServer'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {//  this.serverListYJ = this.propsData.serverList
  },
  methods: {
    open: function open(data) {
      this.serverListYJ = this.propsData.serverList;
      console.log("data===", data);
      this.paramsData.actID = data.actID;
      this.paramsData.startTime = data.startTime == -1 ? '' : data.startTime;
      this.paramsData.middleTime = data.middleTime == -1 ? '' : data.middleTime;
      this.paramsData.endTime = data.endTime == 0 ? '' : data.endTime;
      this.paramsData.env_id = this.propsData.env_id; // this.paramsData.server_id = this.propsData.server_id;

      this.dialogShow = true;
    },
    hiad: function hiad() {
      this.dialogShow = false;
      this.clearData();
    },
    clearData: function clearData() {
      this.paramsData = {
        env_id: '',
        actID: '',
        startTime: '',
        middleTime: '',
        endTime: '',
        server_id: '',
        op: "set"
      }, this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var params = JSON.parse(JSON.stringify(_this.paramsData));
          params.server_id = params.server_id.join(",");
          activityTimeManager(params).then(function (res) {
            if (res.status == 200) {
              _this.$message({
                message: _this.$t('operationSuccess'),
                type: 'success'
              });

              _this.dialogShow = false;

              _this.$emit('update');
            }
          });
        }
      });
    }
  }
};